import { memo, useCallback, createContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignInSection from "./SignInSection";
import PageContainer from "components/PageContainer";
import { AuthSelector } from "redux/selector";
import { signIn } from "redux/reducers/auth";
import { useMount } from "components/hooks";
import { AuthAPI } from "services/auth";

export const LoginContext = createContext();
export const LoginType = {
  NEXT: "NEXT",
  NORMAL: "NORMAL",
};

const SignIn = () => {
  const dispatch = useDispatch();
  const [enableLogin, setEnableLogin] = useState(false);
  const loading = useSelector(AuthSelector.loading);
  const [tabLoginType, setTabLoginType] = useState(LoginType.NEXT);
  const gotoNormalLogin = useCallback(() => setTabLoginType(LoginType.NORMAL), []);
  const gotoQrLoging = useCallback(() => setTabLoginType(LoginType.NEXT), []);

  useMount(() => {
    try {
      (async () => {
        const response = await AuthAPI.checkEnableLogin();
        setEnableLogin(!!response.data.enableLogin);
      })();
    } catch (_) {}
  });

  const onSubmit = useCallback(
    (credentials) => {
      dispatch(signIn(credentials));
    },
    [dispatch]
  );

  return (
    <PageContainer className="SIGN-IN">
      <section className="login-page">
        <div className="section-login">
          <LoginContext.Provider
            value={{ loading, onSubmit, enableLogin, tabLoginType, gotoNormalLogin, gotoQrLoging }}
          >
            <SignInSection />
          </LoginContext.Provider>
        </div>
      </section>
    </PageContainer>
  );
};

export default memo(SignIn);
